module.exports = __webpack_public_path__ + "img/shop_1_ipad.5723394a.png";